/**
 * @file   : BigCards.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/15/2019, 7:58:29 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import SimpleContainer from '../../../external/components/container/SimpleContainer'
import ACol from '../../../external/components/layout/ACol'
import AGrid from '../../../external/components/layout/AGrid'
import ARow from '../../../external/components/layout/ARow'
import Cont from '../../../external/components/layout/Cont'
import Section from '../../../external/components/layout/Section'
import HackMarketingContentWrapper from '../../sharedInternal/container/HackMarketingContentWrapper'
import { isData, isShowCardBack } from '../InfoUtil'
import SectionAd from './SectionAd'
import SectionFlipCard from './SectionFlipCard'
import SectionHeader from './SectionHeader'

const BigCards = ({ intl, theme, section, infoData, mainConfig }) => {
  const getFlipCard = function (content, cardSize) {
    const showCardBack = isShowCardBack(intl, content, infoData)

    // const showCardBack = false

    return (
      <SectionFlipCard
        intl={intl}
        theme={theme}
        content={content}
        infoData={infoData}
        showCardBack={showCardBack}
        cardSize={cardSize}
      />
    )
  }

  if (isData(section) && section.showSection) {
    return (
      <HackMarketingContentWrapper>
        <SimpleContainer>
          <Cont>
            <SectionHeader intl={intl} section={section} infoData={infoData} />
            <AGrid fluid>
              <ARow>
                <ACol xs={6} sm={3} md={3} lg={3}>
                  {getFlipCard(section.content[0], '5x')}
                </ACol>
                <ACol xs={6} sm={3} md={3} lg={3}>
                  {getFlipCard(section.content[1], '5x')}
                </ACol>
                <ACol xs={6} sm={3} md={3} lg={3}>
                  {getFlipCard(section.content[2], '5x')}
                </ACol>
                <ACol xs={6} sm={3} md={3} lg={3}>
                  {getFlipCard(section.content[3], '5x')}
                </ACol>
              </ARow>
            </AGrid>
          </Cont>
        </SimpleContainer>
        <SectionAd section={section} mainConfig={mainConfig} />
        <Section />
      </HackMarketingContentWrapper>
    )
  }

  return null
}

BigCards.propTypes = {
  intl: PropTypes.object.isRequired,
  theme: PropTypes.string.isRequired,
  section: PropTypes.object,
  infoData: PropTypes.object,
  mainConfig: PropTypes.object,
}

export default BigCards
